import { Input } from 'commons/components';
import { ExtendedValidationMessages } from 'commons/components/form-elements/assistive-text';
import type { PocInputValidity } from 'commons/types';
import { useTranslation } from 'core/i18n/i18n';
import {
    MAXIMUM_MONITORING_PERIOD_DAYS,
    MINIMUM_MONITORING_PERIOD_DAYS,
} from 'modules/settings/components/custom-notifications/custom-notification-form.constants';
import {
    CompactInputWrapper,
    FormSection,
    FormSectionTitle,
    MonitoringPeriodRow,
} from 'modules/settings/components/custom-notifications/custom-notification-form.style';
import { preventNonDigitKey } from 'modules/settings/components/custom-notifications/custom-notification-form.utils';

const MONITORING_PERIOD_SUFFIX_KEY = 'settings.custom-notifications.monitoring-period.suffix';

export interface CustomNotificationMonitoringPeriodSectionProps {
    value: string;
    labelKey: string;
    placeholder?: string;
    validity?: PocInputValidity;
    validationMessages?: ExtendedValidationMessages;
    onChange: (value: string) => void;
}

export const CustomNotificationMonitoringPeriodSection: React.FC<CustomNotificationMonitoringPeriodSectionProps> = ({
    value,
    labelKey,
    placeholder,
    validity,
    validationMessages,
    onChange,
}) => {
    const { t } = useTranslation();

    return (
        <FormSection>
            <MonitoringPeriodRow>
                <FormSectionTitle variant="subtitle2">{t(labelKey)}</FormSectionTitle>
                <CompactInputWrapper>
                    <Input
                        name="windowDays"
                        ariaLabel={t(labelKey)}
                        placeholder={placeholder ?? ''}
                        type="number"
                        minValue={MINIMUM_MONITORING_PERIOD_DAYS}
                        maxValue={MAXIMUM_MONITORING_PERIOD_DAYS}
                        value={value}
                        suffix={<>{t(MONITORING_PERIOD_SUFFIX_KEY)}</>}
                        validity={validity}
                        validationMessages={validationMessages}
                        onKeyDown={preventNonDigitKey}
                        onChange={(_, nextValue) => onChange(nextValue ?? '')}
                    />
                </CompactInputWrapper>
            </MonitoringPeriodRow>
        </FormSection>
    );
};
